import React from "react";
import "./App.css";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Header from "./Header";
import MainRegLog from "./MainRegLog";
import Footer from "./Footer";
import RegisteredPage from "./RegisteredPage";
import ProviderDashboard from "./ProviderDashboard";
import DeveloperDashboard from "./DeveloperDashboard";
import AdminDashboard from "./AdminDashboard";
import LogoutComponent from "./LogoutComponent";
import VerifyEmail from "./VerifyEmail";
import PasswordReset from "./PasswordReset";
import ForProviders from "./ForProviders";

function App() {
  return (
    <div>
      <Router>
        <Header />
        <Routes>
          <Route path="/" element={<MainRegLog />} />
          <Route path="/RegisteredPage" element={<RegisteredPage />} />
          <Route path="/ProviderDashboard" element={<ProviderDashboard />} />
          <Route path="/DeveloperDashboard" element={<DeveloperDashboard />} />
          <Route path="/AdminDashboard" element={<AdminDashboard />} />
          <Route path="/LogoutComponent" element={<LogoutComponent />} />
          <Route path="/VerifyEmail" element={<VerifyEmail />} />
          <Route path="/PasswordReset" element={<PasswordReset />} />
          <Route path="/ForProviders" element={<ForProviders />} />
        </Routes>
        <Footer />
      </Router>
    </div>
  );
}

export default App;
